import InfoIcon from 'components/ReusableComponents/Icons/Info'

import styles from './OnHoldWarning.module.scss'

const LimitedInPropertyMessagesWarning = () => {
  return (
    <div className={styles.onHoldWarning}>
      <InfoIcon />
      Your opera integration is limiting reaching out to in-property guests. Not all
      guests may receive theses messages.
    </div>
  )
}

export default LimitedInPropertyMessagesWarning
